import React from "react"
import { cn } from "utils/cn"

const Text = ({ children, className }) => {
  return <p className={cn("text-lg", className)}>{children}</p>
}

export default Text